import { render, staticRenderFns } from "./IconCertificateConiverse.vue?vue&type=template&id=3f0abecf"
import script from "./IconCertificateConiverse.vue?vue&type=script&lang=js"
export * from "./IconCertificateConiverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports